import { getAuthToken } from "jwt-storage-lib";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ZapierTrigger } from "@builder/types/Zapier.type";

const ZAPIER_PATH = "zapier";

export const zapierApi = createApi({
    reducerPath: "zapierApi",
    baseQuery: fetchBaseQuery({
        baseUrl: import.meta.env.VITE_URL_HUB_API,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["zapier"],
    endpoints: builder => ({
        getZapierCustomTriggers: builder.query<ZapierTrigger[], string>({
            query: companyId => `${ZAPIER_PATH}/custom-triggers/${companyId}`,
            providesTags: ["zapier"]
        })
    })
});

export const { useGetZapierCustomTriggersQuery } = zapierApi;
